export default function () {
  return function (scope, element, attrs) {
    var action = () => scope.$apply(function (){
      scope.$eval(attrs.myOnLoad);
    });
    element.on("load", () => action());
  };
}



// WEBPACK FOOTER //
// ./src/logout/my-on-load.js